import { LOOKUP_API } from "../../apiList";

export default class PropertyTypeGateway {
    get() {
        return LOOKUP_API.get("/property-types");
    }
}
